import styled from 'styled-components';

export const ActionPanel = styled.div`
  display: grid;
`;
